import { IExtensionsServerSettings } from '../types/IEditableServerSettings';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface IUpdateExtensionsServerSettingsParams {
  settings: IExtensionsServerSettings;
}

export type IUpdateExtensionsServerSettingsResult = IResult & IExtensionsServerSettings;

export class UpdateExtensionsServerSettingsRequest extends Request<IUpdateExtensionsServerSettingsParams, IUpdateExtensionsServerSettingsResult> {
  constructor(params: IUpdateExtensionsServerSettingsParams) {
    super('updateExtensionsServerSettings', params);
  }
}
